import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';
const getToken = () => localStorage.getItem('notes_token') || '';
const fetchWithAuth = (url, options = {}) => {
  return fetch(url, { ...options, headers: { ...options.headers, 'x-token': getToken() } });
};

export default function CaseManager() {
  const navigate = useNavigate();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    title: '', court: '', caseType: '', status: '进行中', fee: '', client: '', description: ''
  });

  const loadCases = async () => {
    setLoading(true);
    try {
      const res = await fetchWithAuth(`${API_URL}/api/law/cases`);
      const data = await res.json();
      setCases(Array.isArray(data) ? data : []);
    } catch (e) {
      alert('加载失败: ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadCases(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return alert('请输入案件名称');
    try {
      if (editing) {
        await fetchWithAuth(`${API_URL}/api/law/cases/${editing.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(form)
        });
      } else {
        await fetchWithAuth(`${API_URL}/api/law/cases`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(form)
        });
      }
      setShowForm(false);
      setEditing(null);
      setForm({ title: '', court: '', caseType: '', status: '进行中', fee: '', client: '', description: '' });
      loadCases();
    } catch (e) {
      alert('保存失败: ' + e.message);
    }
  };

  const handleEdit = (c) => {
    setEditing(c);
    setForm({
      title: c.title, court: c.court || '', caseType: c.caseType || '',
      status: c.status || '进行中', fee: c.fee || '', client: c.client || '', description: c.description || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定删除此案件？')) return;
    try {
      await fetchWithAuth(`${API_URL}/api/law/cases/${id}`, { method: 'DELETE' });
      loadCases();
    } catch (e) {
      alert('删除失败: ' + e.message);
    }
  };

  const caseTypes = ['劳动争议', '合同纠纷', '知识产权', '公司法务', '刑事辩护', '民事诉讼', '其他'];
  const statusOptions = ['进行中', '已结案', '中止', '和解'];

  return (
    <div className="case-manager">
      <div className="case-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>⚖️ 案件管理</h2>
        <button className="btn-primary" onClick={() => { setEditing(null); setForm({ title: '', court: '', caseType: '', status: '进行中', fee: '', client: '', description: '' }); setShowForm(true); }}>
          + 新增案件
        </button>
      </div>

      {showForm && (
        <div className="case-form-modal" style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.4)', zIndex: 1000,
          display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
          <div style={{
            background: 'white', borderRadius: 12, padding: 24, width: 500, maxHeight: '80vh', overflow: 'auto'
          }}>
            <h3 style={{ margin: '0 0 16px' }}>{editing ? '编辑案件' : '新增案件'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ marginBottom: 12 }}>
                <label>案件名称 *</label>
                <input type="text" value={form.title} onChange={e => setForm({...form, title: e.target.value})} required
                  style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }} />
              </div>
              <div className="form-group" style={{ marginBottom: 12 }}>
                <label>法院/仲裁机构</label>
                <input type="text" value={form.court} onChange={e => setForm({...form, court: e.target.value})}
                  style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }} />
              </div>
              <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                  <label>案件类型</label>
                  <select value={form.caseType} onChange={e => setForm({...form, caseType: e.target.value})}
                    style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }}>
                    <option value="">请选择</option>
                    {caseTypes.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label>状态</label>
                  <select value={form.status} onChange={e => setForm({...form, status: e.target.value})}
                    style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }}>
                    {statusOptions.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                  <label>委托方</label>
                  <input type="text" value={form.client} onChange={e => setForm({...form, client: e.target.value})}
                    style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }} />
                </div>
                <div>
                  <label>代理费(元)</label>
                  <input type="number" value={form.fee} onChange={e => setForm({...form, fee: e.target.value})}
                    style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }} />
                </div>
              </div>
              <div className="form-group" style={{ marginBottom: 16 }}>
                <label>案件描述</label>
                <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})}
                  rows={3} style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 6 }} />
              </div>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setShowForm(false)} style={{
                  padding: '8px 16px', border: '1px solid #ddd', borderRadius: 6, background: 'white', cursor: 'pointer'
                }}>取消</button>
                <button type="submit" style={{
                  padding: '8px 16px', border: 'none', borderRadius: 6, background: '#1a73e8', color: 'white', cursor: 'pointer'
                }}>{editing ? '保存修改' : '创建案件'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>加载中...</div>
      ) : (
        <div className="case-list">
          {cases.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>
              暂无案件，点击"新增案件"开始
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: 8 }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>案件名称</th>
                  <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>类型</th>
                  <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>状态</th>
                  <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>委托方</th>
                  <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>代理费</th>
                  <th style={{ padding: 12, textAlign: 'left', borderBottom: '1px solid #e8e8e8' }}>操作</th>
                </tr>
              </thead>
              <tbody>
                {cases.map(c => (
                  <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: 12 }}>{c.title}</td>
                    <td style={{ padding: 12, color: '#666' }}>{c.caseType || '-'}</td>
                    <td style={{ padding: 12 }}>
                      <span style={{
                        padding: '2px 8px', borderRadius: 4, fontSize: 12,
                        background: c.status === '进行中' ? '#e6f4ea' : c.status === '已结案' ? '#f0f0f0' : '#fef7e0',
                        color: c.status === '进行中' ? '#34a853' : c.status === '已结案' ? '#666' : '#ea4335'
                      }}>{c.status || '进行中'}</span>
                    </td>
                    <td style={{ padding: 12, color: '#666' }}>{c.client || '-'}</td>
                    <td style={{ padding: 12 }}>{c.fee ? `¥${Number(c.fee).toLocaleString()}` : '-'}</td>
                    <td style={{ padding: 12 }}>
                      <button onClick={() => handleEdit(c)} style={{
                        border: 'none', background: 'none', color: '#1a73e8', cursor: 'pointer', marginRight: 8
                      }}>编辑</button>
                      <button onClick={() => handleDelete(c.id)} style={{
                        border: 'none', background: 'none', color: '#ea4335', cursor: 'pointer'
                      }}>删除</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
